import Axios from "axios";
var QuotedPrice = (function () {
    function QuotedPrice() {
    }
    QuotedPrice.prototype.getOrderList = function (params) {
        return Axios.get("supplierclientapi/quotationorder/get_quotation_order_list", { params: params });
    };
    QuotedPrice.prototype.getBusiness = function () {
        return Axios.get("supplierclientapi/supplierpower/quote_business_list");
    };
    QuotedPrice.prototype.getAgent = function (params) {
        return Axios.get("supplierclientapi/supplierpower/quote_business_agent_list", { params: params });
    };
    QuotedPrice.prototype.getRelationCode = function (business_id, supplier_to_business_ids, expiry_start) {
        return Axios.get("supplierclientapi/quotationorder/get_order_list", {
            params: {
                supplier_to_business_ids: supplier_to_business_ids,
                business_id: business_id,
                expiry_start: expiry_start
            }
        });
    };
    QuotedPrice.prototype.create = function (data) {
        return Axios.post("supplierclientapi/quotationorder/save_quotation_order", data);
    };
    QuotedPrice.prototype.editSave = function (data) {
        return Axios.post("supplierclientapi/quotationorder/save_edit_info", data);
    };
    QuotedPrice.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/quotationorder/edit_info", {
            params: params
        });
    };
    QuotedPrice.prototype.getPriceCircleList = function () {
        return Axios.get("supplierclientapi/suppliergoods/price_cycle_list");
    };
    QuotedPrice.prototype.getGoodList = function (params) {
        return Axios.post("supplierclientapi/quotationorder/get_normal_goods_list", params);
    };
    QuotedPrice.prototype.getDayGoodList = function (params) {
        return Axios.get("supplierclientapi/quotationorder/get_daily_goods_list", { params: params });
    };
    QuotedPrice.prototype.getStatus = function () {
        return Axios.get("supplierclientapi/quotationorder/get_order_status");
    };
    QuotedPrice.prototype.submit = function (order_id, null_quotation_alert) {
        return Axios.get("supplierclientapi/quotationorder/submit_quotation_order", {
            params: null_quotation_alert === undefined ? { order_id: order_id } : { order_id: order_id, null_quotation_alert: null_quotation_alert }
        });
    };
    QuotedPrice.prototype.cancel = function (order_id) {
        return Axios.get("supplierclientapi/quotationorder/cancel_quotation_order", {
            params: { order_id: order_id }
        });
    };
    QuotedPrice.prototype.revoke = function (params) {
        return Axios.get("supplierclientapi/quotationorder/recover", { params: params });
    };
    QuotedPrice.prototype.cancelByBusiness = function (business_id) {
        return Axios.get("supplierclientapi/quotationorder/cancel_business_quotation_order", {
            params: { business_id: business_id }
        });
    };
    QuotedPrice.prototype.deleteOrderInfo = function (params) {
        return Axios.get("supplierclientapi/quotationorder/del_order_info", {
            params: params
        });
    };
    QuotedPrice.createInstance = function () {
        QuotedPrice.getInstance();
    };
    QuotedPrice.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return QuotedPrice;
}());
export default QuotedPrice;
